import { render, staticRenderFns } from "./MonthOfAgreement.vue?vue&type=template&id=a8330988&scoped=true&lang=pug&"
import script from "./MonthOfAgreement.vue?vue&type=script&lang=js&"
export * from "./MonthOfAgreement.vue?vue&type=script&lang=js&"
import style0 from "./MonthOfAgreement.vue?vue&type=style&index=0&id=a8330988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8330988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
